class ProductModel extends window.theme.DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    this.modelId = this.element.dataset.modelId;
    this.xrButton = this.mediaContainer.closest('[data-product-single-media-group]')?.parentElement.querySelector('[data-shopify-xr]');

    Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }

    this.modelViewerUI = new Shopify.ModelViewerUI(this.element);
    this.setupModelViewerListeners();
  }

  setupModelViewerListeners() {
    this.mediaContainer.addEventListener('theme:media:visible', () => {
      this.xrButton.setAttribute('data-shopify-model3d-id', this.modelId);

      if (window.theme.touch) {
        return;
      }

      this.modelViewerUI.play();
      this.mediaContainer.dispatchEvent(new CustomEvent('theme:media:play', {bubbles: true}));
    });

    this.mediaContainer.addEventListener('theme:media:hidden', () => {
      this.modelViewerUI.pause();
    });

    this.mediaContainer.addEventListener('xrLaunch', () => {
      this.modelViewerUI.pause();
    });

    this.element.addEventListener('load', () => {
      this.xrButton.setAttribute('data-shopify-model3d-id', this.modelId);
      this.mediaContainer.dispatchEvent(new CustomEvent('theme:media:play', {bubbles: true}));
    });

    this.element.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
      this.pauseOtherMedia();
      setTimeout(() => {
        // Timeout to trigger play event after pause events
        this.mediaContainer.dispatchEvent(new CustomEvent('theme:media:play', {bubbles: true}));
      }, 50);
    });
    this.element.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
      this.mediaContainer.dispatchEvent(new CustomEvent('theme:media:pause', {bubbles: true}));
    });

    this.pauseOtherMedia();
  }
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ModelJson-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

export default ProductModel;
